module.exports = __webpack_public_path__ + "img/opening-day.34a10210.png";